Response payload containing candidate profile summaries.
